import projectUtils from "../../../utils/project-utils.js";

const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

export const sanitizeFilterValue = (value) => (value ?? "").toString().replaceAll("'", "");

export const selectedValue = (option) => option?.value ?? "";

export const selectedValues = (options) => (options ?? []).map(({value}) => value);

export const openDispatchWeb = (navigate, path) => {
    navigate(`${API_DESPACHO_WEB}${path}`, true)
};

export const parseBrDate = (value) => {
    if (!value) return null;
    const [dd, mm, yyyy] = value.split("/");
    if (!dd || !mm || !yyyy) return null;
    return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
};

export const validateDateInterval = (dtStart, dtEnd) => {
    if ((dtStart && !dtEnd) || (!dtStart && dtEnd)) {
        return "Data inicial e data final devem ser preenchidas.";
    }

    if (!dtStart && !dtEnd) return "";

    const start = parseBrDate(dtStart);
    const end = parseBrDate(dtEnd);

    if (start && end && start > end) {
        return "Data inicial não pode ser maior que a final.";
    }

    return "";
};

export const exportGridData = (gridApi, mapRow) => {
    const rows = [];

    gridApi?.forEachNodeAfterFilterAndSort(({data}) => {
        if (data) rows.push(mapRow(data));
    });

    if (!rows.length) {
        projectUtils.swalErrorMessage("", "Nenhum registro para exportar.", "Ok");
        return;
    }

    const csvMaker = (data) => Object.values(data).join(";");
    projectUtils.exportCsvData(csvMaker, rows);
};
